/**
 * Выбор сайта и данных в разделе EO «Виджет» (01.11, ревью b235d4e4; ТЗ 1.17 EMB-019 ч. 1, 2, 4). Чистые функции без api/client,
 * тест — widgetModels.test.ts:
 *  - loadedFor — ответ показывается только для того пути, по которому пришёл: при смене сайта или периода прежний ответ не стоит
 *    под новым выбором (тег сайта A под сайтом B), пока грузится новый или если он не пришёл;
 *  - siteChoices — пункты выбора сайта: сайты с v2 и выбранный, даже без v2 (иначе select показал бы первый пункт, а тег и числа
 *    были бы выбранного);
 *  - keyToggle — «Отозвать» и «Вернуть» ключ шлют нужное состояние (PUT …/toggle {active}), текст — по ответу сервера.
 */
import type { SiteOverview } from "./widgetTypes";

/** Ответ useLoad: данные и путь, по которому они пришли. */
export interface Loaded<T> { path: string | null; data: T | null }
/** Данные для текущего пути: пришли по другому — null («Загружаю…» или ошибка), а не прежний ответ. */
export const loadedFor = <T>(s: Loaded<T>, path: string | null): T | null => (path !== null && s.path === path ? s.data : null);

export interface SiteChoice { id: number; domain: string; v2: boolean }
/** Сайты с v2 по порядку и выбранный сайт без v2 (в начале списка). Выбранного нет в списке сайтов — только сайты с v2. */
export function siteChoices(sites: readonly SiteOverview[], current: number | null): SiteChoice[] {
  const out = sites.filter((s) => s.v2).map((s) => ({ id: s.id, domain: s.domain, v2: true }));
  const cur = current === null ? undefined : sites.find((s) => s.id === current);
  return cur && !cur.v2 ? [{ id: cur.id, domain: cur.domain, v2: false }, ...out] : out;
}
/** Сайт части: выбранный, если он есть среди пунктов (или список ещё не пришёл), иначе первый пункт; пунктов нет — null. */
export function pickSite(choices: readonly SiteChoice[], current: number | null, loaded: boolean): number | null {
  if (current !== null && (!loaded || choices.some((c) => c.id === current))) return current;
  return choices[0]?.id ?? null;
}

/** Отзыв или возврат ключа: тело запроса — нужное состояние; текст — по состоянию, которое вернул сервер. */
export const keyToggle = (ask: "revoke" | "restore"): { body: { active: boolean } } => ({ body: { active: ask === "restore" } });
export function keyToggleText(want: boolean, got: unknown): string {
  if (got !== want) return "Сервер вернул не то состояние ключа — обновите карточку и проверьте";
  return want ? "Ключ снова действует" : "Ключ отозван: сайт получает отказ, виджет показывает контакты";
}
